import { Component, Prop, h } from '@stencil/core';

/**
 * `me-tagline` is a lightweight text component typically used for short,
 * descriptive taglines or subtitles. It allows customization of HTML tag
 * and text alignment.
 */

const COMPONENT_NAME = 'me-tagline';
const DEFAULTS = {
  align: 'left',
} as const;

/**
 * @slot default - {required}, string
 */
@Component({
  tag: 'me-tagline',
  styleUrl: 'index.scss',
  shadow: false,
})
export class Tagline {
  /**
   * The HTML tag used to render the tagline.
   * Useful for controlling semantic meaning (e.g., `h1`–`h6`, `p`, or `div`).
   * @default "p"
   */
  @Prop() tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' = 'p';

  /**
   * Text alignment of the tagline content: left, center, or right.
   * @default "left"
   */
  @Prop() align: 'left' | 'right' | 'center' = DEFAULTS.align;

  render() {
    const Tag = this.tag;

    // Apply alignment class only if it differs from the default
    const alignClass = this.align !== DEFAULTS.align ? `${COMPONENT_NAME}--${this.align}` : '';

    // Build final class string
    const classList = [COMPONENT_NAME, alignClass].filter(Boolean).join(' ');

    // Render the component with the specified tag, classes, and slot content
    return (
      <Tag class={classList}>
        <slot></slot>
      </Tag>
    );
  }
}
